// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"4f5e2a20","726":"c5f2861a"}[chunkId] + ".chunk.js";
};